
import React from "react";
import { Button } from "@/components/ui/button";
import { SectionHeader } from "@/components/ui/section-header";
import { Home, Database, ArrowLeft } from "lucide-react";

interface EmptyStateProps {
  countyName: string;
}

export function EmptyState({ countyName }: EmptyStateProps) {
  return (
    <div className="text-center py-12 bg-gray-50 rounded-lg border border-gray-200">
      <SectionHeader 
        title={`No Nursing Homes Found in ${countyName}`} 
        subtitle="We're working on adding more nursing homes to our database. Here's what you can do in the meantime:"
        centered
      />
      <div className="max-w-lg mx-auto mt-6">
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100 mb-6">
          <Database className="h-8 w-8 text-grandpal-green mx-auto mb-4" />
          <p className="text-grandpal-gray mb-4">
            There might not be any nursing homes for this county in our database yet, 
            or there might be an issue with how the data is stored.
          </p>
        </div>
        
        <ul className="list-disc list-inside space-y-2 text-grandpal-gray text-left mb-6">
          <li>Check the spelling of the county name in the URL</li>
          <li>Try browsing other counties from our homepage</li>
          <li>Contact us if you know of nursing homes in {countyName} that should be listed</li>
        </ul>
        
        <div className="mt-8 flex justify-center space-x-4">
          <Button onClick={() => window.location.href = "/"} className="flex items-center">
            <ArrowLeft className="mr-2 h-4 w-4" />
            Return to Home
          </Button>
        </div>
      </div>
    </div>
  );
}
